import type { RawKey } from './zh-CN';

export const en: Record<RawKey, string> = {
  'tab.lobby': 'Lobby',
  'tab.activity': 'Promos',
  'tab.agent': 'Agent',
  'tab.deposit': 'Deposit',
  'tab.profile': 'Me',

  'action.loginOrRegister': 'Log in',
  'action.login': 'Log in',
  'action.register': 'Sign up',
  'action.close': 'Close',
  'action.settings': 'Settings',
  'action.myAccount': 'My account',
  'action.working': 'Please wait…',
  'action.view': 'View',
  'action.retry': 'Retry',

  'lobby.hot': 'Hot',
  'lobby.more': 'More',
  'lobby.less': 'Less',
  'lobby.providers': 'Game providers',
  'lobby.allProviders': 'All',
  'lobby.otherProvider': 'Other',
  'lobby.title': 'Lobby',
  // 英语要区分单复数 —— 写死 "{n} games" 的话，一款游戏时就是 "1 games"
  'lobby.count_one': '{n} game',
  'lobby.count_other': '{n} games',
  'lobby.none': 'No games available right now',
  'lobby.maintenance': 'Under maintenance',
  'lobby.unavailable': 'Temporarily unavailable',
  'lobby.laterNote': 'Categories, recently played and provider filters are coming later.',
  'lobby.search': 'Search games',
  'lobby.noMatch': 'No games match “{q}”',
  'lobby.liveTables': 'Live tables',
  'lobby.tableClosed': 'Table closed',
  'lobby.liveUnavailable': 'Live data unavailable',
  'lobby.dealer': 'Dealer',
  'lobby.betLimits': 'Bet limits',
  'lobby.players': 'Players',
  'lobby.seats': 'Open seats',
  'lobby.recentResults': 'Recent results',
  'lobby.shoe': 'Banker / Player / Tie',
  'lobby.newTable': 'New table',

  'game.tag_one': '{provider} · {grid} · {n} line',
  'game.tag_other': '{provider} · {grid} · {n} lines',
  'game.tagGrid': '{provider} · {grid}',
  'game.tagLines_one': '{provider} · {n} line',
  'game.tagLines_other': '{provider} · {n} lines',

  'placeholder.activity': 'Promotions, quests, daily check-in, leaderboards — not built yet',
  'placeholder.agent': 'Referral links, downline, commission payouts — not built yet',
  'placeholder.deposit': 'Deposits and withdrawals need the ledger first',
  'placeholder.profile': 'Profile, bet history, security — skeleton lives in Settings for now',

  'auth.phone': 'Phone number',
  'auth.phoneHint': 'Choose your country, then enter your number. Example: {example}',
  'auth.countryLoading': 'Loading country codes…',
  'auth.countryLoadFailed': 'Could not load country codes. Please retry.',
  'auth.registrationClosed': 'Registration is currently closed. Existing accounts can still log in.',
  'err.REGISTRATION_COUNTRY_DISABLED': 'Registration is not available for this country. Choose an enabled country.',
  'auth.countryCode': 'Country calling code',
  'auth.country.PH': 'Philippines',
  'auth.country.BR': 'Brazil',
  'auth.password': 'Password',
  'auth.passwordHint': 'At least 8 characters',
  'auth.toRegister': "Don't have an account? Sign up",
  'auth.toLogin': 'Already have an account? Log in',
  'auth.noSmsYet': 'SMS verification is not built yet — you will not receive a code.',

  'err.BAD_CREDENTIALS': 'Wrong phone number or password',
  'err.IDENTIFIER_TAKEN': 'That phone number is already registered',
  'err.WEAK_PASSWORD': 'Password must be at least 8 characters',
  'err.ACCOUNT_LOCKED': 'Too many attempts. Try again later',
  'err.ACCOUNT_DISABLED': 'This account is frozen',
  'err.NO_SESSION': 'Your session expired. Please log in again',
  'err.BAD_PHONE': 'Invalid phone number — check the selected country and number',
  'history.status.open': 'In progress',
  'history.status.aborted': 'Awaiting settlement',
  'history.status.settled': 'Settled',
  'history.status.canceled': 'Canceled',
  'history.title': 'Bet history',
  'history.empty': 'No rounds yet',
  'history.free': 'Free spin',
  'history.reward': 'Reward',
  'history.adjustment': 'Adjustment',
  'history.more': 'Load more',

  'err.GAME_UNAVAILABLE': "This game is unavailable right now. Try again later",
  'err.NETWORK': "Can't reach the server",
  'err.UNKNOWN': 'Something went wrong. Try again later',

  'profile.balance': 'Balance',
  'profile.vip': 'VIP level',
  'profile.wager': 'Wagering',
  'profile.wagerNone': 'No wagering requirement right now',
  'profile.wagerDone': 'Met',
  'profile.rounds': 'Rounds played',
  'profile.noNickname': 'No nickname yet',
  'profile.editNickname': 'Change nickname',
  'profile.nickname': 'Nickname',
  'profile.nicknameHint': '1–24 characters',
  'profile.nicknameNotUnique': 'Nicknames can repeat — your account is always identified by your ID.',
  'profile.renamesLeft_one': '{n} rename left',
  'profile.renamesLeft_other': '{n} renames left',
  'profile.renamesNone': 'No renames left',
  'profile.idLabel': 'ID {v}',
  'profile.copyId': 'Copy ID',
  'profile.idCopied': 'Copied',
  'profile.copyFailed': "Couldn't copy — long-press the ID to copy it",
  'err.NICKNAME_RENAME_LIMIT': "You've used all your renames",
  'err.BAD_NICKNAME': "That nickname isn't allowed",
  'err.NICKNAME_CHARS': 'Your nickname contains invisible characters — likely from a copy-paste. Please type it in.',
  'action.save': 'Save',
  'profile.changeAvatar': 'Change avatar',
  'profile.uploadOwn': 'Upload your own',
  'profile.uploadHint': 'JPG / PNG / WebP, up to 512 KB',
  'profile.yourUpload': 'Your upload',
  'profile.deposited': '{v} deposited',
  'profile.maxLevel': 'Highest level reached',
  'profile.toNextLevel': 'Deposit {v} more to reach VIP {n}',
  'profile.perkFreeSpins': 'Daily free spins',
  'profile.perkDiscount': 'Deposit bonus',
  'profile.freeSpinsLeft': 'Free spins left',
  'profile.claimDaily': 'Claim today',
  'profile.claimed': 'Claimed today',
  'profile.noRewardYet': 'No reward available',
  'profile.rewardFromLevel': 'Daily free spins start at VIP {n}',
  'vip.title': 'VIP levels',
  'vip.level': 'Level',
  'vip.threshold': 'Deposited',
  'vip.withdrawLimit': 'Daily withdrawal',
  'vip.you': 'you',
  'vip.basis': 'Your VIP level is based on your total qualifying deposits.',
  'vip.noteClaim': 'Daily free spins must be claimed on your profile, once a day. Once claimed they are yours.',
  'vip.noteDiscount': 'The deposit bonus and daily withdrawal limit come with your level — nothing to claim.',
  'vip.noteMinWithdraw': 'Minimum withdrawal per request: {v}.',
  'vip.noteMonotonic': 'Total deposits only go up, so your level never drops.',
  'vip.open': 'View VIP levels',
  'err.NOTHING_TO_CLAIM': 'Your level has no daily reward yet',
  'err.ALREADY_CLAIMED': 'You already claimed today',
  'err.INSUFFICIENT_FUNDS': 'Not enough balance',
  'err.BAD_REQUEST': 'Some of that is not valid',

  'settings.title': 'Settings',
  'settings.skin': 'Theme',
  'settings.mode': 'Appearance',
  'settings.language': 'Language',
  'settings.account': 'Account',
  'settings.notLoggedIn': 'Not logged in.',
  'settings.playerId': 'Player ID',
  'settings.devices': 'Signed-in devices',
  'settings.loading': 'Loading…',
  'settings.unknownDevice': 'Unknown device',
  'settings.current': 'This device',
  'settings.revokeOthers': 'Log out other devices',
  'settings.logout': 'Log out',

  'skin.laroluna': 'LaroLuna · Moonlight',
  'luna.title': 'Find your next favorite.',
  'luna.note': 'A little moonlight. A world of play.',
  'skin.midnight': 'Midnight',
  'skin.sunset': 'Sunset',
  'mode.system': 'System',
  'mode.dark': 'Dark',
  'mode.light': 'Light',

  'time.justNow': 'Active just now',
  'time.minutesAgo_one': '{n} minute ago',
  'time.minutesAgo_other': '{n} minutes ago',
  'time.hoursAgo_one': '{n} hour ago',
  'time.hoursAgo_other': '{n} hours ago',
  'time.daysAgo_one': '{n} day ago',
  'time.daysAgo_other': '{n} days ago',

  // ---- Shop ----
  'shop.title': 'Top up',
  'shop.buy': 'Buy',
  'shop.bought': 'Credited',
  'shop.getCoins': 'You get {v}',
  'shop.bonus': '+{v} bonus',
  'shop.origPrice': 'was {v}',
  'shop.soldOut': "Today's limit reached",
  'shop.leftToday_one': '{n} purchase left today',
  'shop.leftToday_other': '{n} purchases left today',
  'shop.limitToday_one': 'Limit {n} per day',
  'shop.limitToday_other': 'Limit {n} per day',
  'shop.empty': 'Nothing available right now',
  'shop.devPay': 'Development build: purchases are credited instantly, no real payment.',
  'shop.tag.hot': 'Popular',
  'shop.tag.best': 'Best value',
  'shop.tag.daily': 'Daily',
  'shop.tag.first': 'First buy',
  'shop.history': 'Purchase history',
  'shop.noHistory': 'No purchases yet',
  'shop.st.created': 'Awaiting payment',
  'shop.st.paid': 'Crediting',
  'shop.st.credited': 'Credited',
  'shop.st.cancelled': 'Cancelled',
  'shop.st.expired': 'Expired',

  'err.PRODUCT_UNAVAILABLE': "That item isn't available right now",
  'err.PURCHASE_LIMIT': "You've hit today's limit for this item",
  'err.CREDIT_FAILED': 'Payment went through but the coins did not arrive — contact support',

  // ---- Withdraw / payout identity ----
  'withdraw.title': 'Withdraw',
  'withdraw.action': 'Withdraw',
  'withdraw.available': 'Available balance',
  'withdraw.payoutTo': 'Payout details',
  'withdraw.noIdentity': 'No payout details yet',
  'withdraw.bindFirst': 'Add the payee CPF before withdrawing',
  'withdraw.cpf': 'CPF',
  'withdraw.cpfHint': '11 digits, e.g. {example}',
  'withdraw.holderName': 'Payee name',
  'withdraw.holderNameHint': 'Must match the name on the CPF — the bank checks it',
  'withdraw.bind': 'Save payout details',
  'withdraw.bound': 'Saved',
  'withdraw.cannotUnbind': 'These cannot be changed by you. Contact support to update them.',
  'withdraw.oncePerAccount': 'One CPF per account, and each CPF can only be used by one account.',
  'withdraw.wagerBlocked': 'Wagering requirement not met — {v} to go',
  'withdraw.notOpenYet': 'Withdrawals open soon. You can add your payout details now.',

  'err.BAD_CPF': "That CPF isn't valid — please check it",
  'err.IDENTITY_TAKEN': 'That CPF is already in use',
  'err.IDENTITY_ALREADY_BOUND': 'This account already has payout details',

  'withdraw.amount': 'Amount',
  'withdraw.amountHint': '{min} – {max}',
  'withdraw.submit': 'Submit request',
  'withdraw.submitted': 'Request submitted — awaiting review',
  'withdraw.all': 'Max',
  'withdraw.dailyLimit': "Today's limit",
  'withdraw.dailyLeft': '{v} left',
  'withdraw.vipTip': 'VIP {n} can withdraw {v} per day — deposit to raise it',
  'withdraw.history': 'History',
  'withdraw.noHistory': 'No withdrawals yet',
  'withdraw.st.pending': 'Under review',
  'withdraw.st.approved': 'Approved',
  'withdraw.st.rejected': 'Rejected',
  'withdraw.refunded': 'Amount returned to your balance',
  // ---- Mail ----
  'mail.title': 'Messages',
  'mail.entry': 'Messages',
  'mail.empty': 'No messages yet',
  'mail.unknown.title': 'New message',
  'mail.unknown.body': 'You have a new message.',
  'mail.withdrawPaid.title': 'Withdrawal paid',
  'mail.withdrawPaid.body': 'Your withdrawal of {amount} was paid — you received {net} (fee {fee}).',
  'mail.withdrawFailed.title': 'Withdrawal failed',
  'mail.withdrawFailed.body': 'Your withdrawal of {amount} could not be paid. The full amount is back in your balance.',
  'mail.withdrawRejected.title': 'Withdrawal declined',
  'mail.withdrawRejected.body': 'Your withdrawal of {amount} was not approved. The full amount is back in your balance.',
  'mail.attachment': 'Attachment',
  'mail.coins': 'Coins {v}',
  'mail.wager': 'Wagering {v}',
  'mail.wagerNote': 'After claiming, you need to wager this amount before withdrawing',
  'mail.claim': 'Claim',
  'mail.claimed': 'Claimed',
  'mail.claimedOk': 'Claimed {v}',
  'mail.claimedOkWager': 'Claimed {v} — wagering requirement +{w}',
  'err.NO_SUCH_MAIL': "That message doesn't exist",
  'action.more': 'Load more',

  'withdraw.fee': 'Fee',
  'withdraw.feeFree': 'No fee',
  'withdraw.net': 'You receive',
  'withdraw.feeFreeAt': 'No fee from VIP {n}',
  'withdraw.itemFee': 'Fee {f} · received {v}',
  'withdraw.submittedFee': 'Request submitted — you receive {v} (fee {f})',
  'withdraw.noQuotaLeft': "Today's limit is used up",

  'err.NO_PAYOUT_IDENTITY': 'Add your payout details first',
  'err.WAGER_NOT_MET': 'Wagering requirement not met',
  'err.WITHDRAW_TOO_SMALL': 'Below the minimum withdrawal',
  'err.WITHDRAW_OVER_LIMIT': "Over today's withdrawal limit",
  'err.WITHDRAW_NOT_PENDING': 'That request has already been handled',

  // ---------------------------------------------------------------- referral
  'ref.needLogin': 'Sign in to see your share link',
  'ref.myLink': 'My share link',
  'ref.copy': 'Copy',
  'ref.copied': 'Copied',
  'ref.code': 'Invite code: {v}',
  'ref.pending': 'Unclaimed commission',
  'ref.claim': 'Claim',
  'ref.claimed': 'Claimed {v}, +{n} free spins',
  'ref.claimedCash': 'Claimed {v}',
  'ref.spins_one': '{n} free spin',
  'ref.spins_other': '{n} free spins',
  'ref.team': 'My team',
  'ref.level': 'Level {n}',
  'ref.effN_one': '{n} qualified',
  'ref.effN_other': '{n} qualified',
  'ref.tapForList': 'Tap a level to see the list',
  'ref.levelTitle': 'Level {n} referrals',
  'ref.total_one': '{n} person',
  'ref.total_other': '{n} people',
  'ref.noOne': 'Nobody at this level yet',
  'ref.noName': 'No nickname',
  'ref.effective': 'Qualified',
  'ref.notEffective': 'Not yet',
  'ref.prev': 'Previous',
  'ref.next': 'Next',
  'ref.chests': 'Chests',
  'ref.needN_one': '{n} qualified',
  'ref.needN_other': '{n} qualified',
  'ref.leftN_one': '{n} more to go',
  'ref.leftN_other': '{n} more to go',
  'ref.open': 'Open',
  'ref.claimedOne': 'Opened',
  'ref.chestGot': 'Got {v}, +{n} free spins',
  'ref.chestGotCash': 'Got {v}',
  'ref.rules': 'How it works',
  'ref.r1': 'Friends who sign up through your link become your level 1 referrals; their referrals are level 2, and theirs are level 3.',
  'ref.r2': 'A referral qualifies once they have deposited {d} in total and wagered {b} in total.',
  'ref.r3': 'Commission is paid on up to {n} levels, at the rates below, calculated on what your referral actually paid.',
  'ref.r4': 'Commission is not credited automatically — claim it on this page. Reaching a milestone of qualified level 1 referrals unlocks a chest; each chest can be opened once.',
  'ref.tLevel': 'Level',
  'ref.tRate': 'Rate',
  'ref.tSpins': 'Free spins',
  'ref.version': 'Rules version {v}',

  // ---------------------------------------------------------------- payment
  'pay.title': 'Complete payment',
  'pay.amount': 'Amount due',
  'pay.copy': 'Copy PIX code',
  'pay.copied': 'Copied',
  'pay.howto': 'Copy the code, open your bank app and choose PIX "paste code" to pay.',
  'pay.noCode': 'This provider did not give a copyable code — use the payment page below.',
  'pay.openPage': 'Open payment page',
  'pay.expiresIn': 'Expires in {v}',
  'pay.waiting': 'Once you pay, this page updates on its own — no need to leave.',
  'pay.crediting': 'Payment received, crediting…',
  'pay.done': 'Credited',
  'pay.orderNo': 'Order',
  'pay.st.expired': 'This payment code has expired',
  'pay.st.cancelled': 'This order was cancelled',
  'pay.again': 'Start a new order',

  // ---------------------------------------------------------------- in-app frame
  'action.back': 'Back',
  'frame.blocked': 'This page cannot be embedded. Please use the option below instead.',
  'frame.pay': 'Payment',
  'frame.game': 'Game',
  'frame.gameBlocked': 'The game failed to load. Please try again later.',
  'frame.exitGame': 'Back to lobby',
  'pay.toastOk': 'Payment credited, +{v} coins',
};
